import { render } from "./DbsUnlocking.vue?vue&type=template&id=184ff075"
import script from "./DbsUnlocking.vue?vue&type=script&lang=js"
export * from "./DbsUnlocking.vue?vue&type=script&lang=js"
script.render = render

export default script